import { render } from "./InvoiceModel.vue?vue&type=template&id=f41fddda&scoped=true&ts=true"
import script from "./InvoiceModel.vue?vue&type=script&lang=ts"
export * from "./InvoiceModel.vue?vue&type=script&lang=ts"

import "./InvoiceModel.vue?vue&type=style&index=0&id=f41fddda&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalBG\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41fddda"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSpace,QBtn,QList,QItem,QItemSection,QItemLabel,QSeparator,QDialog,QSpinner,QCardActions});qInstall(script, 'directives', {ClosePopup,Ripple});
